import { useCallback } from 'react';

import * as Types from './types';
import { TServerSendResponse } from '../../types';
import { useGenericSend } from '../useGenericSend';

export const useSetPlayerReminders = () => {
    const send = useGenericSend();

    return useCallback(async ({ reminders }: Types.ISetPlayerRemindersRequest): Promise<TServerSendResponse> => {
        const { data } = await send<Types.ISetPlayerRemindersRequest, TServerSendResponse>({
            ID: 36016,
            responses: [36017, 36015],
            description: 'Set player reminders',
            errorLevel: 1,
            reminders
        });

        return data;
    }, [send]);
};
